import { format } from "date-fns";
import { TruncatedText } from "@/components/ui/truncated-text";

interface TestMetaSummaryProps {
  createdBy?: string | null;
  startedAt?: string | null;
  stoppedAt?: string | null;
}

export function TestMetaSummary({ createdBy, startedAt, stoppedAt }: TestMetaSummaryProps) {
  return (
    <div className="grid grid-cols-3 gap-4">
      <div className="space-y-1">
        <p className="text-[10px] uppercase tracking-wider text-muted-foreground font-medium">Created by</p>
        <p className="text-sm text-foreground">
          <TruncatedText>{createdBy ?? "\u2014"}</TruncatedText>
        </p>
      </div>
      <div className="space-y-1">
        <p className="text-[10px] uppercase tracking-wider text-muted-foreground font-medium">Started</p>
        <p className="text-sm text-foreground">
          {startedAt ? format(new Date(startedAt), "MMM d, yyyy") : "\u2014"}
        </p>
      </div>
      <div className="space-y-1">
        <p className="text-[10px] uppercase tracking-wider text-muted-foreground font-medium">Stopped</p>
        <p className="text-sm text-foreground">
          {stoppedAt ? format(new Date(stoppedAt), "MMM d, yyyy") : "\u2014"}
        </p>
      </div>
    </div>
  );
}
